<template>
  <div>
    <iframe
      v-if="isShow"
      :src="iframeSrc"
    />
    <carriersSelectDialog ref="CarriersSelect" @select="handleSelect"></carriersSelectDialog>
  </div>
</template>

<script>
import carriersSelectDialog from '@/pages/orderManage/components/carriersSelectDialog.vue'
import { handleCarrierData } from '@/utils/util';
import env from '../../../../env/index'

export default {
  name: 'DeliveryDetails',
  components: {
    carriersSelectDialog
  },
  data() {
    return {
      iframeSrc: '',
      isShow: false,
      routePath: {
        '/data/historyInventory': 'in-library-management/inventory-management/history-inventory-query', // 历史库存查询
        '/data/deliveryDetails': 'report/particulars', // 出库明细
        '/data/warehousingDetail': 'report/in-warehouse-details', // 入库明细
      }
    }
  },
  mounted() {
    const {creditCode, customerCode}=this.$store.state.user
    if(creditCode){
      this.$refs.CarriersSelect.init()
    } else {
      this.setSrc(customerCode)
    }
  },
  methods: {
    setSrc(customerCode) {
      this.isShow = true
      const path = this.routePath[this.$route.path]
      if (path) {
        const {isConvertEnterprise,enterpriseCustomer}=handleCarrierData()
        const {token}=this.$store.state.user
        this.iframeSrc = `${env.WMS_IFRAME}${path}?source=shipperAPP&token=${token}&customerCode=${customerCode}&is_convert_enterprise=${isConvertEnterprise || false}&enterprise_customer=${JSON.stringify(enterpriseCustomer) || ''}`
      }
    },
    handleSelect(select) {
      this.setSrc(select.customerCode)
    },
  }
}
</script>

<style lang="less" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 120px);
  border: none;
}
.no-permissions {
  text-align: center;
  img {
    width: 248px;
    height: 248px;
  }
}
</style>